module.exports = __webpack_public_path__ + "static/media/GB.38bbf732.png";